import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/storage';
import 'firebase/functions';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_APIKEY,
  authDomain: process.env.REACT_APP_FIREBASE_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MRASUREMENT_ID,
};

const firebaseApp = firebase.initializeApp(firebaseConfig);

export const db = firebaseApp.firestore();
db.enablePersistence({ synchronizeTabs: true });
export const auth = firebaseApp.auth();
export const storage = firebaseApp.storage();
export const functions = firebaseApp.functions('asia-northeast1');
export type result = firebase.auth.ConfirmationResult;
export const phoneProvider = firebase.auth.PhoneAuthProvider;

/**
 * Firebase匿名認証を実行
 * ゲストユーザー用の認証
 */
export const signInAnonymously = async (): Promise<firebase.auth.UserCredential> => {
  try {
    // 匿名認証実行
    const result = await auth.signInAnonymously();
    return result;
  } 
  catch (error) {
    const errorMessage = error instanceof Error
      ? `Firebase認証エラー: ${error.message}`
      : 'Firebase認証エラー: 認証に失敗しました';
    throw new Error(`${errorMessage}。ページを再読み込みしてお試しください。`);
  }
};

/**
 * 現在の認証状態を確認
 */
export const getCurrentUser = (): firebase.User | null => {
  return auth.currentUser;
};

// For use emulator
// db.useEmulator('localhost', 8080);
// functions.useEmulator('localhost', 5000);
